// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MJzV","type":"styles_type__32FzI","choices":"styles_choices__1_wjM"};